import { stripPunctuation } from '../utils/string'
import { Vocab } from '../hooks/useVocab'

const DefinitionText = ({
  vocab,
  isLoading = false,
}: {
  vocab?: Vocab
  isLoading?: boolean
}) => {
  const { word, definitions } = vocab || {}

  const isNoDefinition =
    !definitions || definitions.length === 0

  return (
    <div className="flex flex-col">
      {word && (
        <b className="pb-2">
          {isNoDefinition
            ? stripPunctuation(word.token || '')
            : word.clean}
        </b>
      )}
      {isLoading && (
        <div className="inline-flex cursor-not-allowed items-center px-1 text-sm text-black">
          <svg
            className="-ml-1 mr-3 h-5 w-5 animate-spin text-black"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      )}
      {!isLoading && (
        <>
          {isNoDefinition ? (
            <span>No definition available</span>
          ) : (
            definitions.map(
              (
                { definition, ie, more, partOfSpeech },
                index,
              ) => (
                <span key={index}>
                  <span className="text-sm text-gray-400">
                    {partOfSpeech}
                  </span>
                  {'  '}
                  <span>
                    {ie && !definition ? ie : definition}
                    {ie && definition ? `, ${ie}` : ''}
                    {more && ` (${more})`}
                  </span>
                </span>
              ),
            )
          )}
        </>
      )}
    </div>
  )
}

export default DefinitionText
